import { enrollmentMachine } from '~/machines/enrollment-selection';
import { solarMachine } from '~/machines/solar-funnel';
import { UtilityConnectStatus } from '~/typings/utility-connect';
import { getInitialState } from '~/utils/funnels';
import { constellationFunnelRedirects } from '~/utils/redirects';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    utility: {
      context: { redirect: constellationFunnelRedirects },
    },
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
    enrollment: {
      context: { advanceOn: ['verified', 'timed_out', 'error', 'rejected'] },
    },
  }).withConfig({
    guards: {
      isConstellation: _context => {
        return true;
      },
    },
    services: {
      enrollmentMachine: enrollmentMachine().withConfig({
        guards: {
          shouldAdvance: context => {
            const shouldAdvanceStatus: UtilityConnectStatus[] = [
              'verified',
              'timed_out',
              'error',
              'rejected',
            ];
            return shouldAdvanceStatus.includes(context.utilityConnectStatus!);
          },
          shouldFallBackToAccountNumber: _context => {
            return false;
          },
          shouldFallBackToBillImageUpload: _context => {
            return false;
          },
        },
      }),
    },
  });
